module.exports = __webpack_public_path__ + "static/img/ch_List.5d129050.png";